interface AppConfig {
  BUILD_MODE: 'dev' | 'production';
  BUILD_ENV: string;

  IS_DEV: boolean;

  MAKH_API_URL: string;
  MAKH_URL: string;

  PUSHER_KEY: string;

  DEV_USERNAME?: string;
  DEV_PASSWORD?: string;
}

export const Config: AppConfig = process.env.BUILD_CONFIG as any;

Config.BUILD_MODE = process.env.BUILD_MODE as any;
Config.BUILD_ENV = process.env.BUILD_ENV as any;
Config.MAKH_URL = document.location.origin || Config.MAKH_API_URL;
Config.IS_DEV = Config.BUILD_MODE === 'dev';
